module.exports = __webpack_public_path__ + "static/media/twitter-white.d48f3214.png";